<template>
    <div>
        <content-view>
            <div class="retail-info-detail">
                <a-form :form="form">
                    <a-form-item label="商品所在仓库：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.warehouseName || "-"}}
                    </a-form-item>
                    <a-form-item label="商品名称：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.goodsName || "-"}}
                    </a-form-item>
                    <a-form-item label="商品编号：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.goodsNo || "-"}}
                    </a-form-item>
                    <a-form-item label="商品规格：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.goodsSpecification || "-"}}
                    </a-form-item>
                    <a-form-item label="商品类别：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.categoryName || "-"}}
                    </a-form-item>
                    <a-form-item label="商品单位：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.goodsUnit || "-"}}
                    </a-form-item>
                    <a-form-item label="当前库存数/个：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.availableInventory !== null ? product.availableInventory : "-"}}
                    </a-form-item>
                    <a-form-item label="商品总入库数/个：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.totalInventory !== null ? product.totalInventory : "-"}}
                    </a-form-item>
                    <a-form-item label="商品总销售数/个：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.totalSales !== null ? product.totalSales : "-"}}
                    </a-form-item>
                    <a-form-item label="商品成本价/元：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.costPrice !== null ? product.costPrice : "-"}}
                    </a-form-item>
                    <a-form-item label="商品售卖价/元：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        {{product.sellPrice !== null ? product.sellPrice : "-"}}
                    </a-form-item>
                </a-form>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from 'vuex';
    export default {
        name: 'retailInfoDetail',
        components: {},
        props: {},
        data() {
            return {
                form: this.$form.createForm(this),
                id: this.$route.params.id,
                product: {}
            };
        },
        computed: {
            ...mapGetters(['shopId']),
        },
        watch: {
            shopId() {
                this.retailInfoDetail();
            },
        },
        methods: {
            //商品详情
            retailInfoDetail(params) {
                if (!Boolean(this.shopId)) {
                    return false;
                }
                this.$api.ticketDesk.retailInfoDetail({
                        query: {
                            id: this.id,
                            shopId: this.shopId
                        }
                    }).then(res => {
                        this.product = res;
                    });
            }
        },
        created() {},
        mounted() {
            this.retailInfoDetail();
        }
    };
</script>
<style lang="scss">
    .retail-info-detail {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
    }
</style>